import { AnalysisResult } from "@/components/ResultsSection";
import { supabase } from "@/integrations/supabase/client";

export const analyzeBookCover = async (
  imageBase64: string,
  prompt: string
): Promise<AnalysisResult> => {
  try {
    const { data, error } = await supabase.functions.invoke('analyze-cover', {
      body: { imageBase64, prompt }
    });

    if (error) {
      console.error("Error calling analyze-cover function:", error);
      throw new Error(error.message || "Failed to analyze book cover");
    }

    if (!data) {
      throw new Error("No data returned from analysis");
    }

    return data as AnalysisResult;
  } catch (error) {
    console.error("Error analyzing book cover:", error);
    throw error;
  }
};
